

import product from '../../api/product'

export default { 

    data(){
        return {
            navList : [
                
            ],
            navActive :0,
            page : 1 ,
            pageSize : 10,
            pagelength : 0,
            list : [],
            postMain : false,
        }
    },
    created(){
        this.getType();
    },
    methods : {
        getType(){
            product.selectTypeList({}).then(res=>{
                this.navList = res;
                this.navActive = res[0].id;
                this.getProductList();
            })
        },
        getProductList(bool){
            let {page,pageSize,navActive,list} = this;
            product.selectProductInfos({
                page,pageSize,typeId:navActive
            }).then(res=>{
                bool ? this.list = list.concat(res.pageList) :this.list = res.pageList;
                console.log(this.list)
                this.pagelength = res.total
            });
        },
        changeNav(e){
            if(e == this.navActive)return;
            this.page = 1;
            this.navActive = e;
            this.list = []
            this.postMain = false;
            this.getProductList()
        },
        infinite(){
            if(this.postMain){
                this.page++;
                this.getProductList(true)
            }else{
                this.postMain=true;
            }
            this.$refs.prodScroller.finishInfinite(true)
        },
        pageActive(e){
            this.page = e;
            this.getProductList();
        }
    }

}